<template>
	<div>
		<hr>
		<div class="m-header-wrapper" style="/*width: 3800px;*/">
			<table class="m-header">
				<thead class='bold'>
					<tr>
						<td rowspan="3" class='wide_col'>Субъекты, федеральные округа</td>
					</tr>
					<tr>
						<td colspan='4'>количество актов, размещенных на сайтах субъетов</td>
						<td colspan='4'>количество представленных от ДЛХ по ФО актов ЛПО </td>
						<td colspan='4'>количество рассмотренных актов ЛПО</td>
						<td colspan='2' rowspan='2'>количество заключений о<br>рассмотрении актов ЛПО<br>нарастающим итогом с<br>01.01.{{endYear}}</td>
						<td colspan='2' rowspan='2'>согласовано актов ЛПО</td>
						<td colspan='2' rowspan='2'>не согласовано актов ЛПО</td>
						<td colspan='10'>в том числе по причинам (нарастающим итогом с 01.01.{{endYear}}):</td>
						<td colspan='2'>количество заключений с<br>рекомендациями к<br>проведению выездных<br>проверок</td>
						<td colspan='2'>участие в проведении<br>выездных проверок<br>обоснованности<br>назначения мероприятий<br>по актам ЛПО, шт</td>
						<td class='m-scroll' rowspan="3"></td>
					</tr>
					<tr>
						<td class='m-td' colspan='2'>c 01.01.{{endYear}} по {{end}}</td>
						<td class='m-td' colspan='2'>отчётный период (c<br>{{start}} по {{end}})</td>
						<td class='m-td' colspan='2'>c 01.01.{{endYear}} по {{end}}</td>
						<td class='m-td' colspan='2'>отчётный период (c<br>{{start}} по {{end}})</td>
						<td class='m-td' colspan='2'>c 01.01.{{endYear}} по {{end}}</td>
						<td class='m-td' colspan='2'>отчётный период (c<br>{{start}} по {{end}})</td>
						<td class='m-td' colspan='2'>несоответствие сведений<br>данным ГЛПМ</td>
						<td class='m-td' colspan='2'>несоответствие<br>мероприятий данным<br>ГЛПМ</td>
						<td class='m-td' colspan='2'>несоответствие сведений<br>таксационным<br>характеристикам лесного<br>участка</td>
						<td class='m-td' colspan='2'>недостоверность<br>сведений о санитарном<br>лесопатологическом<br>состоянии лесов (при<br>выездной проверке)</td>
						<td class='m-td' colspan='2'>запрещение или<br>ограничение<br>законодательством<br>Российской Федерации</td>
						<td class='m-td'>c 01.01.{{endYear}}<br>по {{end}}</td>
						<td class='m-td'>отчётный<br>период (c<br>{{start}} по<br>{{end}})</td>
						<td class='m-td'>c 01.01.{{endYear}}<br>по {{end}}</td>
						<td class='m-td'>отчётный<br>период (c<br>{{start}} по<br>{{end}})</td>
					</tr>
					<tr>
						<td>ед. изм.</td>
						<td class='medium_col'>шт.</td>
						<td class='medium_col'>га</td>
						<td class='medium_col'>шт.</td>
						<td class='medium_col'>га</td>
						<td class='medium_col'>шт.</td>
						<td class='medium_col'>га</td>
						<td class='medium_col'>шт.</td>
						<td class='medium_col'>га</td>
						<td class='medium_col'>шт.</td>
						<td class='medium_col'>га</td>
						<td class='medium_col'>шт.</td>
						<td class='medium_col'>га</td>
						<td class='medium_col'>шт.</td>
						<td class='medium_col'>га</td>
						<td class='medium_col'>актов ЛПО,<br>шт</td>
						<td class='medium_col'>га</td>
						<td class='medium_col'>актов ЛПО,<br>шт</td>
						<td class='medium_col'>га</td>
						<td class='medium_col'>актов ЛПО,<br>шт</td>
						<td class='medium_col'>га</td>
						<td class='medium_col'>актов ЛПО,<br>шт</td>
						<td class='medium_col'>га</td>
						<td class='medium_col'>актов ЛПО,<br>шт</td>
						<td class='medium_col'>га</td>
						<td class='medium_col'>актов ЛПО,<br>шт</td>
						<td class='medium_col'>га</td>
						<td class='medium_col'>актов ЛПО,<br>шт</td>
						<td class='medium_col'>га</td>
						<td class='medium_col'>шт.</td>
						<td class='medium_col'>шт.</td>
						<td class='medium_col'>шт.</td>
						<td class='medium_col'>шт.</td>
					</tr>
					<tr>
						<td>1</td>
						<td>2</td>
						<td>3</td>
						<td>4</td>
						<td>5</td>
						<td>6</td>
						<td>7</td>
						<td>8</td>
						<td>9</td>
						<td>10</td>
						<td>11</td>
						<td>12</td>
						<td>13</td>
						<td>14</td>
						<td>15</td>
						<td>16</td>
						<td>17</td>
						<td>18</td>
						<td>19</td>
						<td>20</td>
						<td>21</td>
						<td>22</td>
						<td>23</td>
						<td>24</td>
						<td>25</td>
						<td>26</td>
						<td>27</td>
						<td>28</td>
						<td>29</td>
						<td>30</td>
						<td>31</td>
						<td>32</td>
						<td>33</td>
					</tr>
				</thead>
			</table>
		</div>
		<div class="m-body-wrapper" style="/*width:3800px;*/">
			<table class='m-body'>			
				<tbody>
					<tr v-for='(row, i) in rows'>
						<td v-if='row.flag' colspan="33"><span class="bold">{{row.fo}}</span></td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='left m-td wide_col'>{{row.region}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.placement_all_count}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.placement_all_ga}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.placement_week_count}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.placement_week_ga}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.entrance_all_count}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.entrance_all_ga}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.entrance_week_count}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.entrance_week_ga}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.consideration_all_count}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.consideration_all_ga}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.consideration_week_count}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.consideration_week_ga}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.conclusion_consideration_all_count}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.conclusion_consideration_all_s_mzl}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.decision_good_count}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.decision_good_s_mzl}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.decision_bad_count}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.decision_bad_s_mzl}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.decision_bad_count_sved_glpm}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.decision_bad_s_mzl_sved_glpm}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.decision_bad_count_mer_glpm}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.decision_bad_s_mzl_mer_glpm}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.decision_bad_count_sved_to}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.decision_bad_s_mzl_sved_to}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.decision_bad_count_sved_sansost}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.decision_bad_s_mzl_sved_sansost}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.decision_bad_count_zak_rf}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.decision_bad_s_mzl_zak_rf}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.needs_verification_all_count}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'>{{row.needs_verification_week_count}}</td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'> </td>
						<td v-if='!row.flag' :class='(row.region == "Итого по округу" || row.region == "Итого по РФ") ? "bold" : ""' class='right m-td medium_col'> </td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
	import router from '../../router'
	import {DB} from './../../constants'
	import { EventBus } from '../../lib/EventBus'

	const GET_MONITORING_RLH_REPORT = 'get_monitoring_rlh_report.php'
	const REPORT_ID = 1

	export default {
		name: 'MonitoringRlh',
		data: function () {
			return {
				rows: []
			}
		},
		props: [
			'start',
			'end'
		],
		computed: {
			endYear () {
				return this.$props.end.split('.')[2]
			}
		},
		methods: {
			floatConvert (number) {
			    return +(parseFloat(number).toPrecision(12))
			},
			fillTable (start,end) {
				fetch(DB + GET_MONITORING_RLH_REPORT + '?start=' + start + '&end=' + end)
				.then(res => res.json())
				.then(res => {
					let temp_rows = [{}]
					let flag = true
					let total_summ = {}
					total_summ.region = 'Итого по РФ'
					total_summ.placement_all_count = 0
					total_summ.placement_all_ga = 0
					total_summ.placement_week_count = 0
					total_summ.placement_week_ga = 0
					total_summ.entrance_all_count = 0
					total_summ.entrance_all_ga = 0
					total_summ.entrance_week_count = 0
					total_summ.entrance_week_ga = 0
					total_summ.consideration_all_count = 0
					total_summ.consideration_all_ga = 0
					total_summ.consideration_week_count = 0
					total_summ.consideration_week_ga = 0
					total_summ.conclusion_consideration_all_count = 0
					total_summ.conclusion_consideration_all_s_mzl = 0
					total_summ.decision_good_count = 0
					total_summ.decision_good_s_mzl = 0
					total_summ.decision_bad_count = 0
					total_summ.decision_bad_s_mzl = 0
					total_summ.decision_bad_count_sved_glpm = 0
					total_summ.decision_bad_s_mzl_sved_glpm = 0
					total_summ.decision_bad_count_mer_glpm = 0
					total_summ.decision_bad_s_mzl_mer_glpm = 0
					total_summ.decision_bad_count_sved_to = 0
					total_summ.decision_bad_s_mzl_sved_to = 0
					total_summ.decision_bad_count_sved_sansost = 0
					total_summ.decision_bad_s_mzl_sved_sansost = 0
					total_summ.decision_bad_count_zak_rf = 0
					total_summ.decision_bad_s_mzl_zak_rf = 0
					total_summ.needs_verification_all_count = 0
					total_summ.needs_verification_week_count = 0

					let fo_summ = {}
					fo_summ.region = 'Итого по округу'
					fo_summ.placement_all_count = 0
					fo_summ.placement_all_ga = 0
					fo_summ.placement_week_count = 0
					fo_summ.placement_week_ga = 0
					fo_summ.entrance_all_count = 0
					fo_summ.entrance_all_ga = 0
					fo_summ.entrance_week_count = 0
					fo_summ.entrance_week_ga = 0
					fo_summ.consideration_all_count = 0
					fo_summ.consideration_all_ga = 0
					fo_summ.consideration_week_count = 0
					fo_summ.consideration_week_ga = 0
					fo_summ.conclusion_consideration_all_count = 0
					fo_summ.conclusion_consideration_all_s_mzl = 0
					fo_summ.decision_good_count = 0
					fo_summ.decision_good_s_mzl = 0
					fo_summ.decision_bad_count = 0
					fo_summ.decision_bad_s_mzl = 0
					fo_summ.decision_bad_count_sved_glpm = 0
					fo_summ.decision_bad_s_mzl_sved_glpm = 0
					fo_summ.decision_bad_count_mer_glpm = 0
					fo_summ.decision_bad_s_mzl_mer_glpm = 0
					fo_summ.decision_bad_count_sved_to = 0
					fo_summ.decision_bad_s_mzl_sved_to = 0
					fo_summ.decision_bad_count_sved_sansost = 0
					fo_summ.decision_bad_s_mzl_sved_sansost = 0
					fo_summ.decision_bad_count_zak_rf = 0
					fo_summ.decision_bad_s_mzl_zak_rf = 0
					fo_summ.needs_verification_all_count = 0
					fo_summ.needs_verification_week_count = 0

					let i = 0

					while (i < res.length - 1) {

						if ((res[i].fo === res[i+1].fo) && flag) {
							let obj = {}
							obj.fo = res[i].fo
							obj.flag = true
							flag = false

							if (i !== 0) {
								let clone_fo = {} //клонируем объект для передачи по значению
								for (let key in fo_summ) {
									clone_fo[key] = fo_summ[key]
								}

								temp_rows.push(clone_fo)

								fo_summ.placement_all_count = 0
								fo_summ.placement_all_ga = 0
								fo_summ.placement_week_count = 0
								fo_summ.placement_week_ga = 0
								fo_summ.entrance_all_count = 0
								fo_summ.entrance_all_ga = 0
								fo_summ.entrance_week_count = 0
								fo_summ.entrance_week_ga = 0
								fo_summ.consideration_all_count = 0
								fo_summ.consideration_all_ga = 0
								fo_summ.consideration_week_count = 0
								fo_summ.consideration_week_ga = 0
								fo_summ.conclusion_consideration_all_count = 0
								fo_summ.conclusion_consideration_all_s_mzl = 0
								fo_summ.decision_good_count = 0
								fo_summ.decision_good_s_mzl = 0
								fo_summ.decision_bad_count = 0
								fo_summ.decision_bad_s_mzl = 0
								fo_summ.decision_bad_count_sved_glpm = 0
								fo_summ.decision_bad_s_mzl_sved_glpm = 0
								fo_summ.decision_bad_count_mer_glpm = 0
								fo_summ.decision_bad_s_mzl_mer_glpm = 0
								fo_summ.decision_bad_count_sved_to = 0
								fo_summ.decision_bad_s_mzl_sved_to = 0
								fo_summ.decision_bad_count_sved_sansost = 0
								fo_summ.decision_bad_s_mzl_sved_sansost = 0
								fo_summ.decision_bad_count_zak_rf = 0
								fo_summ.decision_bad_s_mzl_zak_rf = 0
								fo_summ.needs_verification_all_count = 0
								fo_summ.needs_verification_week_count = 0
						}

						temp_rows.push(obj)	

					}
					else {
						fo_summ.placement_all_count += +res[i]. placement_all_count
						fo_summ.placement_all_ga += +res[i].placement_all_ga
						fo_summ.placement_week_count += +res[i].placement_week_count
						fo_summ.placement_week_ga += +res[i].placement_week_ga
						fo_summ.entrance_all_count += +res[i].entrance_all_count
						fo_summ.entrance_all_ga += +res[i].entrance_all_ga
						fo_summ.entrance_week_count += +res[i].entrance_week_count
						fo_summ.entrance_week_ga += +res[i].entrance_week_ga
						fo_summ.consideration_all_count += +res[i].consideration_all_count
						fo_summ.consideration_all_ga += +res[i].consideration_all_ga
						fo_summ.consideration_week_count += +res[i].consideration_week_count
						fo_summ.consideration_week_ga += +res[i].consideration_week_ga
						fo_summ.conclusion_consideration_all_count += +res[i].conclusion_consideration_all_count
						fo_summ.conclusion_consideration_all_s_mzl += +res[i].conclusion_consideration_all_s_mzl
						fo_summ.decision_good_count += +res[i].decision_good_count
						fo_summ.decision_good_s_mzl += +res[i].decision_good_s_mzl
						fo_summ.decision_bad_count += +res[i].decision_bad_count
						fo_summ.decision_bad_s_mzl += +res[i].decision_bad_s_mzl
						fo_summ.decision_bad_count_sved_glpm += +res[i].decision_bad_count_sved_glpm
						fo_summ.decision_bad_s_mzl_sved_glpm += +res[i].decision_bad_s_mzl_sved_glpm
						fo_summ.decision_bad_count_mer_glpm += +res[i].decision_bad_count_mer_glpm
						fo_summ.decision_bad_s_mzl_mer_glpm += +res[i].decision_bad_s_mzl_mer_glpm
						fo_summ.decision_bad_count_sved_to += +res[i].decision_bad_count_sved_to
						fo_summ.decision_bad_s_mzl_sved_to += +res[i].decision_bad_s_mzl_sved_to
						fo_summ.decision_bad_count_sved_sansost += +res[i].decision_bad_count_sved_sansost
						fo_summ.decision_bad_s_mzl_sved_sansost += +res[i].decision_bad_s_mzl_sved_sansost
						fo_summ.decision_bad_count_zak_rf += +res[i].decision_bad_count_zak_rf
						fo_summ.decision_bad_s_mzl_zak_rf += +res[i].decision_bad_s_mzl_zak_rf
						fo_summ.needs_verification_all_count += +res[i].needs_verification_all_count
						fo_summ.needs_verification_week_count += +res[i].needs_verification_week_count

						total_summ.placement_all_count += +res[i].placement_all_count
						total_summ.placement_all_ga += +res[i].placement_all_ga
						total_summ.placement_week_count += +res[i].placement_week_count
						total_summ.placement_week_ga += +res[i].placement_week_ga
						total_summ.entrance_all_count += +res[i].entrance_all_count
						total_summ.entrance_all_ga += +res[i].entrance_all_ga
						total_summ.entrance_week_count += +res[i].entrance_week_count
						total_summ.entrance_week_ga += +res[i].entrance_week_ga
						total_summ.consideration_all_count += +res[i].consideration_all_count
						total_summ.consideration_all_ga += +res[i].consideration_all_ga
						total_summ.consideration_week_count += +res[i].consideration_week_count
						total_summ.consideration_week_ga += +res[i].consideration_week_ga
						total_summ.conclusion_consideration_all_count += +res[i].conclusion_consideration_all_count
						total_summ.conclusion_consideration_all_s_mzl += +res[i].conclusion_consideration_all_s_mzl
						total_summ.decision_good_count += +res[i].decision_good_count
						total_summ.decision_good_s_mzl += +res[i].decision_good_s_mzl
						total_summ.decision_bad_count += +res[i].decision_bad_count
						total_summ.decision_bad_s_mzl += +res[i].decision_bad_s_mzl
						total_summ.decision_bad_count_sved_glpm += +res[i].decision_bad_count_sved_glpm
						total_summ.decision_bad_s_mzl_sved_glpm += +res[i].decision_bad_s_mzl_sved_glpm
						total_summ.decision_bad_count_mer_glpm += +res[i].decision_bad_count_mer_glpm
						total_summ.decision_bad_s_mzl_mer_glpm += +res[i].decision_bad_s_mzl_mer_glpm
						total_summ.decision_bad_count_sved_to += +res[i].decision_bad_count_sved_to
						total_summ.decision_bad_s_mzl_sved_to += +res[i].decision_bad_s_mzl_sved_to
						total_summ.decision_bad_count_sved_sansost += +res[i].decision_bad_count_sved_sansost
						total_summ.decision_bad_s_mzl_sved_sansost += +res[i].decision_bad_s_mzl_sved_sansost
						total_summ.decision_bad_count_zak_rf += +res[i].decision_bad_count_zak_rf
						total_summ.decision_bad_s_mzl_zak_rf += +res[i].decision_bad_s_mzl_zak_rf
						total_summ.needs_verification_all_count += +res[i].needs_verification_all_count
						total_summ.needs_verification_week_count += +res[i].needs_verification_week_count

						for (let key in fo_summ) {
							if (key !== 'region')
								fo_summ[key] = +this.floatConvert(fo_summ[key])
						}

						for (let key in total_summ) {
							if (key !== 'region')
								total_summ[key] = +this.floatConvert(total_summ[key])
						}

						temp_rows.push(res[i])
						if (res[i].fo !== res[i+1].fo) {
							flag = true
						}
						i++
					}
				}

				let last = res.length - 1

				temp_rows.push(res[last])

				fo_summ.placement_all_count += +res[last]. placement_all_count
				fo_summ.placement_all_ga += +res[last].placement_all_ga
				fo_summ.placement_week_count += +res[last].placement_week_count
				fo_summ.placement_week_ga += +res[last].placement_week_ga
				fo_summ.entrance_all_count += +res[last].entrance_all_count
				fo_summ.entrance_all_ga += +res[last].entrance_all_ga
				fo_summ.entrance_week_count += +res[last].entrance_week_count
				fo_summ.entrance_week_ga += +res[last].entrance_week_ga
				fo_summ.consideration_all_count += +res[last].consideration_all_count
				fo_summ.consideration_all_ga += +res[last].consideration_all_ga
				fo_summ.consideration_week_count += +res[last].consideration_week_count
				fo_summ.consideration_week_ga += +res[last].consideration_week_ga
				fo_summ.conclusion_consideration_all_count += +res[last].conclusion_consideration_all_count
				fo_summ.conclusion_consideration_all_s_mzl += +res[last].conclusion_consideration_all_s_mzl
				fo_summ.decision_good_count += +res[last].decision_good_count
				fo_summ.decision_good_s_mzl += +res[last].decision_good_s_mzl
				fo_summ.decision_bad_count += +res[last].decision_bad_count
				fo_summ.decision_bad_s_mzl += +res[last].decision_bad_s_mzl
				fo_summ.decision_bad_count_sved_glpm += +res[last].decision_bad_count_sved_glpm
				fo_summ.decision_bad_s_mzl_sved_glpm += +res[last].decision_bad_s_mzl_sved_glpm
				fo_summ.decision_bad_count_mer_glpm += +res[last].decision_bad_count_mer_glpm
				fo_summ.decision_bad_s_mzl_mer_glpm += +res[last].decision_bad_s_mzl_mer_glpm
				fo_summ.decision_bad_count_sved_to += +res[last].decision_bad_count_sved_to
				fo_summ.decision_bad_s_mzl_sved_to += +res[last].decision_bad_s_mzl_sved_to
				fo_summ.decision_bad_count_sved_sansost += +res[last].decision_bad_count_sved_sansost
				fo_summ.decision_bad_s_mzl_sved_sansost += +res[last].decision_bad_s_mzl_sved_sansost
				fo_summ.decision_bad_count_zak_rf += +res[last].decision_bad_count_zak_rf
				fo_summ.decision_bad_s_mzl_zak_rf += +res[last].decision_bad_s_mzl_zak_rf
				fo_summ.needs_verification_all_count += +res[last].needs_verification_all_count
				fo_summ.needs_verification_week_count += +res[last].needs_verification_week_count

				total_summ.placement_all_count += +res[last].placement_all_count
				total_summ.placement_all_ga += +res[last].placement_all_ga
				total_summ.placement_week_count += +res[last].placement_week_count
				total_summ.placement_week_ga += +res[last].placement_week_ga
				total_summ.entrance_all_count += +res[last].entrance_all_count
				total_summ.entrance_all_ga += +res[last].entrance_all_ga
				total_summ.entrance_week_count += +res[last].entrance_week_count
				total_summ.entrance_week_ga += +res[last].entrance_week_ga
				total_summ.consideration_all_count += +res[last].consideration_all_count
				total_summ.consideration_all_ga += +res[last].consideration_all_ga
				total_summ.consideration_week_count += +res[last].consideration_week_count
				total_summ.consideration_week_ga += +res[last].consideration_week_ga
				total_summ.conclusion_consideration_all_count += +res[last].conclusion_consideration_all_count
				total_summ.conclusion_consideration_all_s_mzl += +res[last].conclusion_consideration_all_s_mzl
				total_summ.decision_good_count += +res[last].decision_good_count
				total_summ.decision_good_s_mzl += +res[last].decision_good_s_mzl
				total_summ.decision_bad_count += +res[last].decision_bad_count
				total_summ.decision_bad_s_mzl += +res[last].decision_bad_s_mzl
				total_summ.decision_bad_count_sved_glpm += +res[last].decision_bad_count_sved_glpm
				total_summ.decision_bad_s_mzl_sved_glpm += +res[last].decision_bad_s_mzl_sved_glpm
				total_summ.decision_bad_count_mer_glpm += +res[last].decision_bad_count_mer_glpm
				total_summ.decision_bad_s_mzl_mer_glpm += +res[last].decision_bad_s_mzl_mer_glpm
				total_summ.decision_bad_count_sved_to += +res[last].decision_bad_count_sved_to
				total_summ.decision_bad_s_mzl_sved_to += +res[last].decision_bad_s_mzl_sved_to
				total_summ.decision_bad_count_sved_sansost += +res[last].decision_bad_count_sved_sansost
				total_summ.decision_bad_s_mzl_sved_sansost += +res[last].decision_bad_s_mzl_sved_sansost
				total_summ.decision_bad_count_zak_rf += +res[last].decision_bad_count_zak_rf
				total_summ.decision_bad_s_mzl_zak_rf += +res[last].decision_bad_s_mzl_zak_rf
				total_summ.needs_verification_all_count += +res[last].needs_verification_all_count
				total_summ.needs_verification_week_count += +res[last].needs_verification_week_count

				for (let key in fo_summ) {
					if (key !== 'region')
						fo_summ[key] = +this.floatConvert(fo_summ[key])
				}

				for (let key in total_summ) {
					if (key !== 'region')
						total_summ[key] = +this.floatConvert(total_summ[key])
				}

				let clone_fo = {} //клонируем объект для передачи по значению
				for (let key in fo_summ) {
					clone_fo[key] = fo_summ[key]
				}

				temp_rows.push(clone_fo)

				temp_rows[0] = total_summ

				this.rows = temp_rows
			})
				.catch(err => console.log(err))
			}
		},
		mounted () {
			this.rows = []
			this.fillTable(this.start, this.end)

			EventBus.$on('monitoring-rlh-date', date => {
				// console.log('mon',date)
				this.fillTable(date.start, date.end)
			})

			const dispay_width = document.documentElement.clientWidth
			const dispay_height = document.documentElement.clientHeight
			let scroll_width = 17

			const ua = navigator.userAgent
			if (ua.search('OPR/') > 0) {
				scroll_width = 15
			}

			//const table_width = dispay_width - 30 - scroll_width
			//const col_width = Math.ceil((table_width) / 23)

			document.querySelectorAll('.wide_col').forEach(td => {
				td.width = 215
			})

			document.querySelectorAll('.medium_col').forEach(td => {
				td.width = 95
			})

			//document.querySelector('.m-header-wrapper').width = table_width
			//document.querySelector('.m-body-wrapper').width = table_width
			document.querySelector('.m-body-wrapper').style.maxHeight = `${dispay_height - 440}px`

			// console.log(dispay_width, col_width, table_width)

			document.querySelector('.m-scroll').width = scroll_width
			//document.querySelector('.m-body-wrapper').style.paddingRight = `${scroll_width}px`

			let f = false
			document.querySelector('.m-header-wrapper').addEventListener('scroll', (e) => {
				if(f)
				{
					f = false
					return
				}
				f = true
				document.querySelector('.m-body-wrapper').scrollLeft = e.target.scrollLeft
			})
			document.querySelector('.m-body-wrapper').addEventListener('scroll', (e) => {
				if(f)
				{
					f = false
					return
				}
				f = true
				document.querySelector('.m-header-wrapper').scrollLeft = e.target.scrollLeft	
			})
			
		},
		updated() {
			document.querySelectorAll('.wide_col').forEach(td => {
				td.width = 215
			})

			document.querySelectorAll('.medium_col').forEach(td => {
				td.width = 95
			})
		},
		created() {
			/*if(!this.$parent.$parent.reports.some((e) => {
				return e.id == REPORT_ID
			}))
				router.replace('/main')*/
		},
		beforeDestroy() {
			EventBus.$off('monitoring-rlh-date')
		}
	}
</script>

<style scoped>
	.left {
		text-align: left;
		padding-left: 2px;
	}

	.right {
		text-align: right;
		padding-right: 10px;
	}

	div.m-header-wrapper {
		border: 1px solid black;
		border-bottom: none;  
		overflow-x: auto;
		/*width: 1574px;*/
		/*width: 1634px;*/
	}

	div.m-body-wrapper {
		/*overflow-x: hidden;
		overflow-y: auto;
		width: 1574px;
		width: 1634px;*/
		overflow-x: auto;
		border: 1px solid black;
		border-top: none;
	}

	table.m-header {
		border-bottom: 1px solid black;
		width: 3274px;
		table-layout: auto;
	}

	table.m-body {
		table-layout: auto;
		width: 3255px;
	}
	
 	td.m-td,  th.m-td {
	vertical-align: middle;  
	/*width: 120px;*/
	/*width: 124px;*/
	word-wrap: break-word;
	} 

	td.small_col {
		/*width: 83px;*/
	}

	td.medium_col {
		/*width: 95px;*/
	}

	td.wide_col {
		/*width: 215px;*/
	}
	/* td.m-scroll {
		width: 14px;
		width: 17px;
	} */
</style>



// WEBPACK FOOTER //
// MonitoringRlh.vue?1415824b